<template>
	<div class="choseGuarantee">
		<maskBox>
			<div class="innerBox">
				<div class="choseEle">请先选择出函机构</div>
				<div class="innerTopPart">
					<div class="guarantee-item" v-for="(item, index) in bankListAll" @click="choseGuaranteeFun(item)">
						<el-radio v-model="choseRadio" :label="index">
							<img :class="['guarantee-img', targetGauran != null && item.orgNo == targetGauran.orgNo ? 'choseActive' : '']" :src="item.logo" />
						</el-radio>
					</div>
				</div>
				<div class="feeClass">
					<div class="innerFeeClass" v-for="(item, indx) in ruleForm" v-if="choseRadio != -1">
						<p style="min-width: 80px; ">{{ item }} :</p>
						<p v-if="targetGauran != null" style="line-height: 17px;">
							<span :style="
									indx == 'totleMoney' ? 'color: red;margin: 0 10px;' : ''
								">{{targetGauran['guaranteePrice'] ==-1?targetGauran['errorMsg']: targetGauran[indx] }}</span>
							<span v-if="indx == 'totleMoney' && targetGauran['guaranteePrice'] !=-1" style=" margin-left: 10px;">元</span>
						</p>
					</div>
				</div>
				<div class="agreeMentClass">
					<div v-if="targetGauran != null && targetGauran.agreementName">
						<el-checkbox v-model="readingFlag">
							<span class="checkClass">我同意 </span>
							<span @click.stop="openFile" style="cursor:pointer;color: #1890FF;vertical-align: middle;">{{ targetGauran.agreementName }}</span>
						</el-checkbox>
					</div>
					<!-- 福建省平台渠道需要签署分离式保函申请书 -->
					<div v-if="targetGauran != null && isSignApplication">
						<el-checkbox  v-model="signApplication" @change='signCheckBoxChange'>
							<span class="checkClass">签署</span>
							<span @click.stop="clickApplication" style="cursor:pointer;color: #1890FF;vertical-align: middle;">《分离式保函申请书》</span>
						</el-checkbox>
					</div>
				</div>

				<div class="innerBottomArea">
					<el-button @click="close">关 闭</el-button>
					<el-button type="primary" :disabled="targetGauran && targetGauran.guaranteePrice == -1" @click="sure">确 认</el-button>
				</div>
			</div>
		</maskBox>
		<el-dialog v-loading='loading' width="800px"  :visible="showApplication" title="签署协议" @close='showApplication = false'>
			<div style="height: calc(100vh - 200px);">
				<iframe :src="'./pdf/web/viewer.html?file='+ applicationFileUrl" style="width: 100%; height: 100%" />
			</div>
			<div style="margin-top: 10px;">
				<el-button class="btn" @click='showApplication = false'>关闭</el-button>
				<el-button v-if="!signApplication" type="primary" class="btn" @click='sureSign'>确认签署并提交</el-button>

			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		props: {
			orderDetail: {
				type: Object,
				require: false,
			},
			show: {
				type: Boolean,
				require: false,
			},
		},
		computed:{
			isSignApplication(){
				let list = ['0017','0019','0024','0025','0007','0030','0031']
				if(list.includes(this.orderDetail.applicantChannel)&&this.targetGauran.parentOrganId == '15601'){
					return true
				}
				
			}
		},
		data() {
			return {
				loading:false,
				signApplication:false,
				applicationFileUrl:'',
				showApplication: false,
				choseRadio: -1,
				readingFlag: false,
				bankListAll: [],
				ruleForm: {
					// orgName: "金 融 机 构",
					totleMoney: "保费金额",
					// guaranteePrice: "保费单价(元)",
					// plateFee: "平 台 费(元)",
				},
				targetGauran: null,
				targetSignFile: null
			};
		},
		mounted() {
			this.requestEle();
		},
		methods: {
			
			// 选择出函机构的回调函数
			choseGuaranteeFun(item) {
				this.targetGauran = item;
				this.$set(
					this.targetGauran,
					"totleMoney",
					Number(item.guaranteePrice) + Number(item.plateFee)
				);
				// 切换之后同意申请书保持为false
				this.readingFlag = false;
				// 
				if(this.isSignApplication){
					this.requestAppliction()
				}
			},
			// 根据当前区域码和订单编号获取当前订单可选择的出函机构
			requestEle() {
				let addrNo = this.orderDetail.addrNo;
				let result = addrNo.split("_");
				let data1 = {
					bcrId: result[result.length - 1],
					amountGuaranteed: this.orderDetail.amountGuaranteed,
					orderNo:this.orderDetail.orderNo
				};
				this.requestAPI.queryOrganFeeList(data1).then((res) => {
					this.bankListAll = res.data;
					this.bankListAll.forEach((item, index) => {
						item["plateFee"] = 0;
						if (item['logo'] != 'undefined' && item['logo'] != null) {
							// 内网测试环境需修改
							// if (this.publicMethed.publicUrlPre != 'tiantai' && this.publicMethed.publicUrlPre != 'eletter') {
							// 	let logo = item['logo'].replace("https://", "http://")
							// 	item['logo'] = logo.replace("4430", "8080")
							// }
							this.$set(this.bankListAll, item, index)
						}
					})
				});
			},
			close() {
				this.$emit("update:show", false);
			},
			sure() {
				if (this.targetGauran == null) {
					this.$message.error("请先选择出函机构");
					return;
				}
				if (this.targetGauran.guaranteePrice == -1) {
					return
				}
				if (!this.readingFlag && this.targetGauran.agreementName) {
					this.$message.error("请先同意投标保函承诺书");
					return;
				}
				if (this.isSignApplication && this.signApplication == false) {
					this.$message.error("请先签署申请书");
					return;
				}
				let data1 = {
					orderNo: this.orderDetail.orderNo,
					acId: this.targetGauran.acId,
					channel: this.orderDetail.applicantChannel,
				};
				this.requestAPI.UpdateOrderInfoOrg(data1).then((res) => {
					if (res.errorCode == "0000") {
						this.orderDetail.orderStatus = 2;
						this.orderDetail.guaranteeName = this.targetGauran.enterpriseName;
						this.orderDetail.guaranteeId = this.targetGauran.enterpriseId;
						// 付款信息中用的是订单总金额
						this.orderDetail.acId = this.targetGauran.acId;
						this.orderDetail.totalFee = this.targetGauran.guaranteePrice;
						this.orderDetail.guaranteePrice = this.targetGauran.guaranteePrice;
						this.orderDetail.branchName = this.targetGauran.orgName;

                        this.getSaveGuaranteeLetter();//保存担保函
						this.$emit("update:orderDetail", this.orderDetail);
						this.close();
						this.$emit("successBack");
					}
				});
            },
            // 保存担保函
            getSaveGuaranteeLetter(){
                // console.log(this.orderDetail);
                let obj = {
                    orderNo: this.orderDetail.orderNo
                }
                this.requestAPI.saveGuaranteeLetter(obj);
            },
			// 获取签署信息
			requestAppliction(){
				this.requestAPI.queryBhAppMessage({
					orderNo: this.orderDetail.orderNo
				}).then((res) => {
					if(res.data.isSign){
						this.targetSignFile = res.data
						this.signApplication = true
					}
				})
			},
			
			// 确认签署分离式保函申请书
			sureSign() {
				this.loading = true
				this.requestAPI.signBhApplicationForm({
					orderNo: this.orderDetail.orderNo,
					bidderId:this.userInfo.enterpriseId,
					guaranteeId:this.targetGauran.guaranteeId
				}).then((res) => {
					this.loading = false
					this.targetSignFile = res.data
					this.$message.success('签署成功！')
					let obj = {
						fileUrl: res.data.hadoopContractUrl
					}
					this.publicMethed.downLoadImageC(obj, (res, type) => {
						this.applicationFileUrl = res
					})
					this.signApplication = true
				}).catch(()=>{
					this.loading = false
				})
			},
			// 签署协议check回调
			signCheckBoxChange(){
				if(this.targetSignFile != null){
					this.signApplication = true
					if(this.applicationFileUrl == ''){
						let obj = {
							fileUrl: this.targetSignFile.hadoopContractUrl
						}
						this.publicMethed.downLoadImageC(obj, (res, type) => {
							this.applicationFileUrl = res
							window.open('./pdf/web/viewer.html?file='+ this.applicationFileUrl,
							 "_blank")
						})
					}else{
						window.open('./pdf/web/viewer.html?file='+ this.applicationFileUrl,
						 "_blank")
					}
				}else{
					this.signApplication = false
					this.showApplication = true
					this.requestAPI.previewBhApplicationForm({
						orderNo: this.orderDetail.orderNo
					}).then((res) => {
						this.applicationFileUrl = this.publicMethed.base64ToFile(res.data, 'application/pdf').url
					})
				}
				
				
			},
			// 点击查看或者签署分离式保函申请书
			clickApplication(){
				this.applicationFileUrl = ''
                this.showApplication = true
			},
			// 显示承诺书
			openFile() {
				window.open(this.targetGauran.agreementUrl,
					"_blank")
			},
		},
	};
</script>
<style>
	/* { */
	.innerTopPart::-webkit-scrollbar {
		/*滚动条整体样式*/

		width: 6px !important;
		/*高宽分别对应横竖滚动条的尺寸*/
		height: 6px !important;
		background: #ffffff !important;
		cursor: pointer !important;
	}

	/*滚动条里面小方块*/
	.innerTopPart::-webkit-scrollbar-thumb {
		border-radius: 5px !important;
		-webkit-box-shadow: inset 0 0 5px #ABABAB !important;
		background: #f1f1f1 !important;
		cursor: pointer !important;
	}

	/*滚动条里面轨道*/
	.innerTopPart::-webkit-scrollbar-track {
		/* -webkit-box-shadow: inset 0 0 5px #001529 !important; */
		border-radius: 0 !important;
		background: #f1f1f1 !important;
		cursor: pointer !important;
	}
</style>
<style lang="less" scoped>
	/deep/ .el-dialog{
		margin-top: 20px !important;
		.el-dialog__body {
			padding: 10px 20px;
		}
		
	}
	.choseGuarantee {
		.innerBox {
			padding: 10px 30px;
			max-width: 50vw;
			min-width: 600px;
			border-radius: 8px;
			background-color: white;

			.choseEle {
				line-height: 55px;
				text-align: center;
				font-size: 15px;
				font-weight: 600;
			}

			.innerTopPart {
				padding: 5px 30px;
				max-height: 50vh;
				overflow: auto;
				margin-bottom:10px;
				.guarantee-item{
					.guarantee-img{
						margin-left: 10px;
						height: 75px;
					}
				}
			}

			.el-radio {
				display: flex;
				// justify-content: center;
				align-items: center;

				/deep/ .el-radio__inner {
					border: 1px solid #adb5c6;
				}

				/deep/.el-radio__input.is-checked .el-radio__inner {
					border-color: #409eff;
				}

				/deep/ .el-radio__label {
					width: 65%;
					padding-left: 0;
				}
			}

			.feeClass {
				display: flex;
				flex-wrap: wrap;
				min-height: 28px;

				.innerFeeClass {
					padding-left: 30px;
					color: black;
					display: flex;
					// width: 50%;
					align-items: center;
					line-height: 28px;
				}
			}

			.innerBottomArea {
				text-align: center;
				padding: 15px 0;
			}

			.agreeMentClass {
				padding: 5px 30px;
				min-height: 30px;

			}

			/deep/ .el-checkbox__label {
				padding-left: 0;
			}

			/deep/ .el-checkbox__inner {
				border: 1px solid;
			}

			.checkClass {
				margin: 0 2px 0 6px;
				color: black;
				cursor: pointer;
				vertical-align: middle;
			}

			.choseActive {
				border: 1px solid #409eff;
			}
		}
	}
</style>
